<template>
  <div class="view">
    <h1>{{$t('bookings.title')}}</h1>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Bookings',
  mounted () {
    if (this.$router.currentRoute.params.room) {
      // console.log('book', this.$router.currentRoute.params.room)
    }
  }
}
</script>
